import React,{useState,useEffect,useRef, useContext} from 'react';
import './Home.css';
import { Toaster } from 'react-hot-toast';
import { ModalFilter, ModalRealizarCobro, ModalAutorizarTramite, ModalFinalizarProceso, ModalRegresarTramite, ModalTwoColumnsOtProcesos,ModalModificarCostoTramite } from '../../utils/modals';
import { number_format } from "../../utils/utils";
import moment from "moment";
import "moment/locale/es";
import { Row,Col,Form, Button, } from 'react-bootstrap';
import TablaRecibos from '../TablaRecibos/TablaRecibos';
import { useSelector,useDispatch,getState } from 'react-redux'; 
import { setInitData,setStateHome, setStateGlobal, } from '../../reducers/appReducer';
import { RightSidebarNuevaCotizacion, } from '../RightSidebar/RightSidebar';

import { AuthContext } from '../../auth/AuthContext';
import { Navigate } from 'react-router-dom';

moment.locale("mx");

export const HomeProcesos = ({typeView, socket}) => {

  const { usuario } = useContext(AuthContext);

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  const { 
    section, 
    showModalRecibos,
    recibosSearch,
    customDate,
    fechaInicio,
    fechaFin,
  } = stateHome;

  let { 

    dataTramite,
    showSidebarModificarOT,
    showModalVisualizarOT,
  } = stateGlobal;

  const refDateToday = useRef(null);
  const refDateTomorrow = useRef(null);
  const today = moment().add(-1, 'year').format('YYYY-MM-DD');
  const tomorrow = moment(today,'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD');
  const [state,setState] = useState({ changeTab: false });

  const setModalVisualizarOT = (opt) => {
    dispatch( setStateGlobal( { showModalVisualizarOT: opt, } ) );
  }

  const setSidebarModificarOT = (opt) => {
    dispatch( setStateHome( { showSidebarModificarOT: opt, } ) );
  }

  const handleSetSection = (section) => {
    const { arrSections } = stateHome
    let newSection = {...arrSections, ...section }
    dispatch( setStateHome( { arrSections: newSection } ) )
  }

  const handleSubmitSearch = (e) => {
    getTramitesByDate()
    e.preventDefault();
  }


  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })


  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }
  
  useEffect(() => {
    window.addEventListener('resize', detectSize)
    return () => window.removeEventListener('resize', detectSize)
  }, [windowDimenion])

  useEffect(() => {
    dispatch(setStateHome( { 
      isLoadPanel: true,
      fechaInicio: today,
      fechaFin: tomorrow,
      customDate: true
    }));
    if(!customDate){
      dispatch( setStateHome( {
        fechaInicio: today, fechaFin: tomorrow,
        arrSections: {
          cotizaciones: true,
          orden_trabajo: true,
          caja: false,
          creditos: false,
          finanzas: false,
          procesos: false,
        }
       } ) )
    }
  },[]);

  useEffect(() => {
    if(stateHome.customDate){
      getTramitesByDate();
    }
  },[stateHome.customDate]);

  const getTramitesByDate = () =>{
    dispatch(setStateHome( { isLoadPanel: true}));
    const data = {
      date_start: refDateToday.current.value,
      date_end: refDateTomorrow.current.value 
    };
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesByDate',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( setStateGlobal({ dataArray: response.documents, }) )
      dispatch( setStateHome( { isLoadPanel: false}) );
    })
  }

  const getViewContrato = (dataRecibo) => {
  }

  const updateOT = () => {

    let _dataTramite = [], _tmp = dataTramite, canProcess = false
    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {

        let status = 2

        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status,
        })

      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {

        canProcess = _tmp.arrOT[0].arrProcess[a - 1].status === 2 ? true : false

        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: canProcess ? 1 : 0,
        })

      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }


    }

    const dataUpdate = {
      info: dataTramite.arrOT[0].info,
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
     method: 'POST',
     mode: 'cors',
     body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
     alert('Orden de trabajo terminada con éxito')
     socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
    })

  }

  const searchData = recibosSearch.toLowerCase();
  let filteredData = [];
  let dataArray = stateGlobal.dataArray;

  if (recibosSearch == "") {
    filteredData = dataArray;
  } else {
    filteredData = dataArray.filter((el) => {
      const { nombre, concepto2 } = el;
      return (
        nombre?.toLowerCase().includes(searchData) ||
        concepto2?.toLowerCase().includes(searchData)
      );
    });
  }

  if(usuario.logged){
    if(usuario.tipo_usuario!=='4'){
        return <Navigate to="/login" />
    }
  }

  return (
    <div className="container-fluid">
      <div className="ws-main-container">
        {/* Filtros */}
        <div className="ws-tab-container pb-3">
          {/* Tab section */}
          <Row>
            <Col>
              {/* Formulario de búsqueda por rango de fecha */}
              <Form onSubmit={handleSubmitSearch} className="d-flex align-items-end flex-md-row gap-2 ws-main-datebar">
                <Form.Group className="mb-1">
                  <Form.Control ref={refDateToday} type="date" defaultValue={fechaInicio} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Control ref={refDateTomorrow} type="date" defaultValue={fechaFin} />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Button type="submit" className="ws-btn-blue-2">&nbsp;&nbsp;<i className="bi bi-search pe-2"></i>{ windowDimenion.winWidth > windowDimenion.winHeight &&( "Buscar") }</Button>
                </Form.Group>
              </Form>
              <br />
            </Col>
          </Row>
          {/* Formulario de búsqueda por filtro ingresado */}
          <Row className="mt-3">
            <Col xs={12}> 
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group className="group-search">
                  <i className="bi bi-search pe-2"></i>
                  <Form.Control 
                  type="search"
                  className="ws-input-search"
                  placeholder="Filtrar por nombre, trámite, fecha..."
                  onChange={ (e) => dispatch( setStateHome( { recibosSearch: e.target.value } ) ) }
                  />
                </Form.Group>
              </Form>
            </Col>
            <Col xs={1}>
              <div className="ws-group-icons-tools d-flex justify-content-center align-items-center">
                {/*<i className="bi bi-filter ws-icon-options-tools" title="Filtrar por"></i>
                <i className="bi bi-download ws-icon-options-tools" title="Descargar reporte"></i>*/}
              </div>
            </Col>
          </Row>
        </div>
        {/* TABLA DE LOS RECIBOS */}
        <TablaRecibos 
        state={state} 
        setState={setState}
        filteredData={filteredData} 
        typeView={typeView}
        />

        <ModalRealizarCobro socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalRealizarCobro: false, }))
        }} />  
        <ModalAutorizarTramite socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalAutorizarTramite: false, }))
        }} />  
        <ModalFinalizarProceso socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalFinalizarProceso: false, }))
        }} />  
        <ModalRegresarTramite  
        socket={socket} 
        handleClose={ () => {
          dispatch( setStateGlobal({ showModalRegresarTramite: false, }))
        }}
        typeView={typeView}
        />
        <ModalModificarCostoTramite  socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalModificarCostoTramite: false, }))
        }}/>
        {/* TOAST NOTIFICATION */}
        <Toaster position='top-right' />

        {/* MODAL OT - TWO COLUMNS */}
        <ModalTwoColumnsOtProcesos 
        title="Visualizar orden de trabajo" 
        socket={socket} show={showModalVisualizarOT} 
        handleClose={ () => setModalVisualizarOT(false) } 
        typeView={typeView}
        />

        <RightSidebarNuevaCotizacion status={showSidebarModificarOT} setStatus={() => setSidebarModificarOT(true)} title="Modificar orden de trabajo" onClose={() => { window.location.reload() }} onSave={ () => updateOT() } >
          <Form>
            <Row className="ws-form-group-divider pb-3 pt-3">
              
              {
                dataTramite.arrOT && dataTramite.arrOT[0].info.map((t,e) => (
                  <Col key={`list-${e}`} xs={12} lg={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="ws-form-label">  
                        {t.nombre}
                      </Form.Label>
                      <Form.Control name={t.id} type={t.tipo} multiple={(t.tipo==='file') ? true : false}
                      onChange={ (ev) => {

                        /*
                        dataTramite.arrOT[0].info[e].value = ev.target.value

                        const newData = {...dataTramite}
                        const newObj = newData.formulario.map((element) => {
                          if(element.id===t.id){
                            if(t.tipo==='file'){
                              t.value = ev.target.files;
                            }else{
                              t.value = ev.target.value
                            }
                          }
                          return element;
                        })
                        */

                       } }
                      />
                    </Form.Group>
                  </Col>
                ))
              }
              <hr />

            </Row>
          </Form>
        </RightSidebarNuevaCotizacion>
      </div>
    </div>
  )
}
